import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip', {
    staticClass: "mt-20"
  }), _c('my-enter-search', {
    staticClass: "mb-20",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('span', {
    staticClass: "form-item-label"
  }, [_vm._v(_vm._s(_vm.t('账单号')) + _vm._s(_vm.tc('：')))]), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "data-permission": "finance_billing_bill_number",
      "id": "finance_billing_bill_number",
      "allowClear": "",
      "maxLength": 50
    },
    model: {
      value: _vm.searchData.bill_number,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "bill_number", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "searchData.bill_number"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "ml-15 form-item-select",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u6237\u7F16\u7801"),
      "data-permission": "finance_billing_account_code",
      "id": "finance_billing_account_code",
      "show-tip": "",
      "placeholder": _vm.t('账户编码'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.account_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "account_code", $$v);
      },
      expression: "searchData.account_code"
    }
  }, _vm._l(_vm.accountList, function (item) {
    return _c('a-select-option', {
      key: item.account_code,
      attrs: {
        "value": item.account_code
      }
    }, [_vm._v(_vm._s(item.account_code))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "ml-15 form-item-select",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u903E\u671F"),
      "data-permission": "finance_billing_is_overdue",
      "id": "finance_billing_is_overdue",
      "show-tip": "",
      "placeholder": _vm.t('是否逾期'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.is_overdue,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "is_overdue", $$v);
      },
      expression: "searchData.is_overdue"
    }
  }, _vm._l(_vm.yesNoStatus, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('span', {
    staticClass: "form-item-label"
  }, [_vm._v(_vm._s(_vm.t('账单周期')) + _vm._s(_vm.tc('：')))]), _c('my-range-picker', {
    attrs: {
      "data-permission": "finance_billing_datetime",
      "id": "finance_billing_datetime",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.searchData.timeArr,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "timeArr", $$v);
      },
      expression: "searchData.timeArr"
    }
  })], 1), _c('span', {
    staticClass: "ml-20",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "finance_billing_list_query",
      "data-permission": "finance_billing_search",
      "id": "finance_billing_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(" " + _vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "finance_billing_list_reset",
      "data-permission": "finance_billing_reset",
      "id": "finance_billing_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "ovh mb-15"
  }, [_c('span', {
    staticClass: "fl",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('div', {
    staticClass: "ml-20 fl"
  }, [_c('a-dropdown', [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "billing_export_all",
      "id": "billing_export_all",
      "data-sign": "finance_billing_list_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "billing_export_selected",
      "id": "billing_export_selected",
      "data-sign": "finance_billing_list_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', [_vm._v(" " + _vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "data-sign": "finance_billing_list",
      "fixed-header": "",
      "is-filter-box": "",
      "useMouseTool": "",
      "name": "billingList",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "row-key": "bill_number",
      "row-selection": {
        selectedRowKeys: _vm.selectedList,
        onChange: _vm.onSelectChange
      },
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "mainBody",
      fn: function (ref) {
        var record = ref.record;
        return [_c('div', {
          staticClass: "code-box"
        }, [_c('span', {
          staticClass: "code-label"
        }, [_vm._v(_vm._s(_vm.t('账户编号：')))]), _c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record['account_code'],
            expression: "record['account_code']"
          }],
          staticClass: "code-content"
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record['account_code'])))])]), _c('div', {
          staticClass: "code-box"
        }, [_c('span', {
          staticClass: "code-label"
        }, [_vm._v(_vm._s(_vm.t('签约主体：')))]), _c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record['main_body']['sign_body_name'],
            expression: "record['main_body']['sign_body_name']"
          }],
          staticClass: "code-content"
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record['main_body']['sign_body_name'])))])]), _c('div', {
          staticClass: "code-box"
        }, [_c('span', {
          staticClass: "code-label"
        }, [_vm._v(_vm._s(_vm.t('服务主体：')))]), _c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record['main_body']['service_body_name'],
            expression: "record['main_body']['service_body_name']"
          }],
          staticClass: "code-content"
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record['main_body']['service_body_name'])))])]), _c('div', {
          staticClass: "code-box"
        }, [_c('span', {
          staticClass: "code-label"
        }, [_vm._v(_vm._s(_vm.t('签约业务：')))]), _c('span', {
          staticClass: "code-content"
        }, [_vm._v(_vm._s(record['main_body']['sign_business_type_list_text'].length ? record['main_body']['sign_business_type_list_text'].join(',') : '--'))])])];
      }
    }, {
      key: "allTotal",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._l(record['all_total'], function (item, index) {
          return _c('div', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item['balance'],
              "currency": item['currency_code'],
              "formatter": true
            }
          })], 1);
        }), !record['all_total'].length ? _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]) : _vm._e()];
      }
    }, {
      key: "startBalance",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._l(record['start_balance'], function (item, index) {
          return _c('div', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item['balance'],
              "currency": item['currency_code'],
              "formatter": true
            }
          })], 1);
        }), !record['all_total'].length ? _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]) : _vm._e()];
      }
    }, {
      key: "endBalance",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._l(record['end_balance'], function (item, index) {
          return _c('div', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item['balance'],
              "currency": item['currency_code'],
              "formatter": true
            }
          })], 1);
        }), !record['all_total'].length ? _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]) : _vm._e()];
      }
    }, {
      key: "cashBackBalance",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._l(record['cash_back_balance'], function (item, index) {
          return _c('div', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item['balance'],
              "currency": item['currency_code'],
              "formatter": true
            }
          })], 1);
        }), !record['all_total'].length ? _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]) : _vm._e()];
      }
    }, {
      key: "verified_amount",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._l(record.verified_amount, function (item, index) {
          return _c('div', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item['balance'],
              "currency": item['currency_code'],
              "formatter": true
            }
          })], 1);
        }), !record['verified_amount'].length ? _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]) : _vm._e()];
      }
    }, {
      key: "unverified_amount",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._l(record.unverified_amount, function (item, index) {
          return _c('div', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item['balance'],
              "currency": item['currency_code'],
              "formatter": true
            }
          })], 1);
        }), !record['unverified_amount'].length ? _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]) : _vm._e()];
      }
    }, {
      key: "overdue_msg",
      fn: function (ref) {
        var record = ref.record;
        return [record.overdue_bill_list.length ? _c('div', {
          staticClass: "table-inside-box"
        }, [_c('div', {
          staticClass: "table-inside-cell",
          staticStyle: {
            "height": "100%"
          }
        }, _vm._l(record.overdue_bill_list, function (item, index) {
          return _c('ul', {
            key: index,
            staticClass: "table-inside-row"
          }, [_c('li', {
            staticClass: "table-inside-td text-right",
            staticStyle: {
              "width": "150px"
            }
          }, [_c('money-format', {
            staticStyle: {
              "display": "inline-block"
            },
            attrs: {
              "num": item.overdue_amount,
              "currency": item.currency_code,
              "formatter": true
            }
          })], 1), _c('li', {
            staticClass: "table-inside-td text-right",
            staticStyle: {
              "width": "150px"
            }
          }, [_vm._v(_vm._s(item.overdue_day) + $t("\u5929"))])]);
        }), 0)]) : _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])];
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('a-dropdown', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: ['finance_billing_export'],
            expression: "['finance_billing_export']"
          }]
        }, [_c('a', {
          staticClass: "ant-dropdown-link mr-10",
          attrs: {
            "data-permission": "finance_billing_download",
            "id": "finance_billing_download",
            "fbu-analyse-name": $t("\u4E0B\u8F7D")
          }
        }, [_vm._v(_vm._s(_vm.t('下载')) + " "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', [_c('a', {
          attrs: {
            "href": "javascript:",
            "data-permission": "finance_billing_bills",
            "id": "finance_billing_bills",
            "download": "",
            "fbu-analyse-name": $t("\u8D26\u5355")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDownloadFinance(record.bill_number);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('账单')))])]), record.statement_url_list && record.statement_url_list.length ? _c('a-menu-item', [_c('a', {
          attrs: {
            "href": "javascript:",
            "data-permission": "finance_billing_statement",
            "id": "finance_billing_statement",
            "fbu-analyse-name":
            /*no-i18n-auto*/
            'Statement'
          },
          on: {
            "click": function ($event) {
              return _vm.handleDownloadStatement(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('Statement')))])]) : _vm._e(), record.sap_certificate_file ? _c('a-menu-item', [_c('a', {
          attrs: {
            "href": "javascript:",
            "download": "",
            "fbu-analyse-name": $t("\u5B9E\u62A5\u5B9E\u9500\u9644\u4EF6")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDownloadSapFile(record.bill_number);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('实报实销附件')))])]) : _vm._e()], 1)], 1)], 1);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "name": "billingList",
      "isFixed": "",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };